"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data: function data() {
    return {
      formValidate: {
        autoReplySwitch: 0,
        // 自动好评开关
        autoReplyTime: 5,
        // 自动好评时间
        autoReplyContent: '好评' // 好评内容
      },
      ruleValidate: {
        autoReplyContent: [{
          required: true,
          message: '',
          trigger: 'none'
        }]
      }
    };
  },
  mounted: function mounted() {
    // 获取评论配置
    this.getCommentSetting();
  },
  methods: {
    // 获取评论配置
    getCommentSetting: function getCommentSetting() {
      var _this = this;
      (0, _store.getCommentSettingApi)().then(function (res) {
        _this.formValidate = res;
      }).catch(function (err) {
        _this.$message.error(err.message);
      });
    },
    // 提交
    submit: function submit() {
      var _this2 = this;
      (0, _store.setCommentSettingApi)(this.formValidate).then(function (res) {
        _this2.$message.success('保存成功');
      }).catch(function (err) {});
    }
  }
};